import React from 'react';
import { Box, RadioButton, Text } from '@common-fe/common-fe';

import { FieldLevelAccessValue } from '../role.types';

interface Props {
  index: number;
  testId?: string;
  name: string;
  value?: FieldLevelAccessValue;
  onSetValue?: (value: FieldLevelAccessValue) => void;
  isEditMode?: boolean;
}
const FieldLevelAccessGroupItem: React.FC<Props> = ({
  testId,
  index,
  name,
  value,
  onSetValue,
  isEditMode,
}) => {
  return (
    <Box direction='row' margin={{bottom: 'm'}}>
      <Box direction='row' width={{max: '280px', min: '280px'}} margin={{ right: 'spacing12'}}>
        <Box width={{min: '32px'}}>
          <Text size="medium" color="textDisabled" weight={400}>
            {index}
          </Text>
        </Box>
        <Text weight={700} title={name} truncate size="medium" data-testid={`${testId||''}_name`}>
          {name}
        </Text>
      </Box>
      <Box direction='row' width="145px" justify='between'>
        <RadioButton 
          checked={value === FieldLevelAccessValue.View}
          disabled={!isEditMode}
          name={`${testId||''}_view`}
          onChange={onSetValue && (() => onSetValue(FieldLevelAccessValue.View))}
          data-testid={`${testId||''}_view`}
        />
        <RadioButton
          checked={value === FieldLevelAccessValue.Edit}
          disabled={!isEditMode}
          name={`${testId||''}_edit`}
          onChange={onSetValue && (() => onSetValue(FieldLevelAccessValue.Edit))}
          data-testid={`${testId||''}_edit`}
        />
        <RadioButton
          checked={value === FieldLevelAccessValue.Hide}
          disabled={!isEditMode}
          name={`${testId||''}_hide`}
          onChange={onSetValue && (() => onSetValue(FieldLevelAccessValue.Hide))}
          data-testid={`${testId||''}_hide`}
        />
      </Box>
      
    </Box>
    
  );
};

export default FieldLevelAccessGroupItem;